import React, {useState, useEffect} from 'react'
import {FaBars, FaTimes, FaGithub, FaFacebook, FaTwitter, FaLinkedin} from 'react-icons/fa'
import {BsFillPersonLinesFill} from 'react-icons/bs'
import Logo from '../assets/logo.png'
import {Link} from 'react-scroll'
import Patryk_Romanski_CV from './PatrykRomanskiCV.pdf'
import { motion } from 'framer-motion'


const Navbar = () => {

    const [nav, setNav] = useState(false);
    const handleClick = () => setNav(!nav);

    // change color nav
    const [color, setColor] = useState('transparent');

    useEffect(() => {
        const changeColor = () => {
        if(window.scrollY >= 100){
            setColor('rgba(220, 220, 220, 0.6)')
        } else {
            setColor('transparent')
        }
    };
        window.addEventListener('scroll', changeColor);
    }, []);

  return (
    <div style={{backgroundColor: `${color}`}}
    className='fixed z-10 w-full h-[70px] flex justify-between items-center px-4 text-black duration-300 backdrop-blur-sm'>
        <motion.div initial={{ y: -100 }} animate={{ y: 0 }}  transition={{
        duration: 0.9,
        delay: 1
       }}>
        <Link to='home' smooth={true} duration={500}><img className='cursor-pointer' src={Logo} alt="personal_logo" style={{width: '90px'}}/> </Link>
        </motion.div>
        {/* Menu */}
            <motion.ul initial={{ y: -100 }} animate={{ y: 0 }}  transition={{
        duration: 0.9,
        delay: 1
       }} className='hidden md:flex'>
                <li className='hover:text-[#858585] hover:scale-105 hover:bg-gray hover:rounded duration-75'>
                    <Link to='home' smooth={true} duration={500}>Home</Link>
                </li>
                <li className='hover:text-[#858585] hover:scale-105 hover:bg-gray hover:rounded duration-75'>
                <Link to='skills' smooth={true} duration={500}>Skills</Link>
                </li>
                <li className='hover:text-[#858585] hover:scale-105 hover:bg-gray hover:rounded duration-75'>
                    <Link to='about' smooth={true} duration={500}>About me</Link>
                </li >
                <li className='hover:text-[#858585] hover:scale-105 hover:bg-gray hover:rounded duration-75'><Link to='experience' smooth={true} duration={500}>Experience</Link></li>
                <li className='hover:text-[#858585] hover:scale-105 hover:bg-gray hover:rounded duration-75'>
                <Link to='contact' smooth={true} duration={500}>Contact</Link>
                </li>
            </motion.ul>

        {/* Hamburger */}
        <div onClick={handleClick} className="md:hidden z-10 duration-100">
            {!nav ? <FaBars /> : <FaTimes />}
        </div>

        {/* Mobile Menu */}
        <ul className={nav ? 'absolute top-0 left-0 w-full h-screen bg-[#d4d4d4] flex flex-col justify-center items-center duration-200' : 'absolute top-0 left-[-100%] w-full h-screen bg-[#d4d4d4] flex flex-col justify-center items-center duration-200'}>   
            <li className='py-6 text-4xl'><Link onClick={handleClick} to='home' smooth={true} duration={500}>Home</Link></li>
            <li className='py-6 text-4xl'><Link onClick={handleClick} to='skills' smooth={true} duration={500}>Skills</Link></li>
            <li className='py-6 text-4xl'><Link onClick={handleClick} to='about' smooth={true} duration={500}>About me</Link></li>
            <li className='py-6 text-4xl'><Link onClick={handleClick} to='experience' smooth={true} duration={500}>Experience</Link></li>
            <li className='py-6 text-4xl'><Link onClick={handleClick} to='contact' smooth={true} duration={500}>Contact</Link></li>
            <div className='flex gap-4 mt-4'>
                <li className='w-[50px] h-[50px] flex justify-between items-center ml-[0px] bg-blue-700 rounded-md'>
                    <a className='font-bold flex justify-between items-center w-full text-white' target='_blank' href='https://www.facebook.com/profile.php?id=100080271055271 targ'><FaFacebook size={30} /></a>
                </li>
                <li className='w-[50px] h-[50px] flex justify-between items-center ml-[0px] bg-[#333333] rounded-md'>
                    <a className='font-bold flex justify-between items-center w-full text-white' target='_blank' href='https://github.com/PatrykR01'><FaGithub size={30} /></a>
                </li>
                <li className='w-[50px] h-[50px] flex justify-between items-center ml-[0px] bg-blue-500 rounded-md'>
                    <a className='font-bold flex justify-between items-center w-full text-white' href='https://www.linkedin.com/in/patryk-roma%C5%84ski-497860235/' target='_blank'><FaLinkedin size={30} /> </a>
                </li>
                <li className='w-[50px] h-[50px] flex justify-between items-center ml-[0px] bg-[#da3f3f] rounded-md'>
                    <a className='font-bold flex justify-between items-center w-full text-white' href={Patryk_Romanski_CV} download="Patryk_Romanski_CV" target='_blank' rel='noopener noreferrer'><BsFillPersonLinesFill size={30} /></a>
                </li>
            </div>
        </ul>

        {/* Social icons */}
        <motion.div initial={{ x: -100 }} animate={{ x: 0 }}  transition={{
            delay: 1,
            duration: 0.9,
       }} className='hidden lg:flex fixed flex-col top-[350%] left-0'>
            <ul>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-200 bg-[#d4d4d4] hover:bg-blue-700 rounded-tr-lg hover:rounded-lg'>
                    <a className='font-bold flex justify-between items-center w-full text-white' target='_blank' href='https://www.facebook.com/profile.php?id=100080271055271 targ'>
                        Facebook <FaFacebook size={30} />
                    </a>
                </li>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-200 bg-[#d4d4d4] hover:bg-[#333333] hover:rounded-lg'>
                    <a className='font-bold flex justify-between items-center w-full text-white' target='_blank' href='https://github.com/PatrykR01'>
                        GitHub <FaGithub size={30} />
                    </a>
                </li>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-200 bg-[#d4d4d4] hover:bg-blue-500 hover:rounded-lg'>
                    <a className='font-bold flex justify-between items-center w-full text-white' href='https://www.linkedin.com/in/patryk-roma%C5%84ski-497860235/' target='_blank'>
                    LinkedIn<FaLinkedin size={30} /> 
                    </a>
                </li>
                <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-200 bg-[#d4d4d4] hover:bg-[#da3f3f] rounded-br-lg hover:rounded-lg'>
                    <a className='font-bold flex justify-between items-center w-full text-white' href={Patryk_Romanski_CV} download="Patryk_Romanski_CV" target='_blank' rel='noopener noreferrer'>
                        Resume <BsFillPersonLinesFill size={30} />
                    </a>
                </li>
            </ul>
        </motion.div>
    </div>
  )
}

export default Navbar